
      // 为React应用提供必要的全局变量：根据 Vite 模式动态设置 NODE_ENV
      window.process = window.process || { env: {} };
      window.process.env.NODE_ENV = import.meta.env.MODE === 'production' ? 'production' : 'development';
    